import React, { useEffect, useState } from "react";
import { useAuthUser } from "react-auth-kit";
import PageBackBtn from "../../../../../../../components/Buttons/PageBackBtn";
import BuyAddons from "./subComponents/BuyAddons";
import StreamsTable from "./subComponents/StreamsTable";
import CreditTable from "./subComponents/CreditTable";
import CancelBtn from "../../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../../components/Buttons/SaveBtn";
import {
  getCreditDitribution,
  getStreams,
} from "../../../../service/IntegrationsSlice";
import { Button, FormHelperText } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { editCreditData } from "../../../../service/IntegrationsSlice";
import { AppDispatch } from "../../../../../../../redux/store";
import styles from "../../Meta.module.css";
import TableSkeleton from "../../../../../../../components/Skeletons/TableSkeleton";
import { getSubDomainAccessStatus } from "../../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import EditIcon from "@mui/icons-material/Edit";
import editIcon from "../../../../../../../assets/images/edit-w-new.svg";

type CreditData = {
  branchId: string | number;
  credit: number;
};

function CreditTab(props: any) {
  const { handleTabChange, handleTabSelect } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch: AppDispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const {
    metaCreditDitribution,
    metaCreditDitributionLoading,
    streamsLoading,
    metaStreams,
    editCreditDataSuccess,
    editCreditDataLoading,
  } = useSelector((state: any) => state.appIntegrations);

  const { branchList } = useSelector((state: any) => state.branch);

  const [stage, setStage] = useState<Number>(0);
  const [creditEdit, setCreditEdit] = React.useState<boolean>(false);
  const [creditEditedData, setCreditEditedData] = useState<CreditData[]>([]);
  const [branch, setBranch] = useState<any>(null);
  const [totalCreditRemaining, setTotalCreditReamining] = useState();

  const handleCreditChange = (branchId: any, e: any) => {
    setCreditEditedData((prev) => {
      const existingIndex = prev.findIndex(
        (previtem) => previtem?.branchId === branchId
      );

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          credit: Number(e.target.value),
        };
        return updated;
      } else {
        return [...prev, { branchId, credit: Number(e?.target.value) }];
      }
    });
  };

  const handleConfirmEdit = () => {
    const data = {
      instituteId: userById?.instituteId,
      branchData: creditEditedData,
      updatedById: userById?.updatedById,
      updatedByName: userById?.updatedByName,
    };
    dispatch(editCreditData(data));
  };
  const cancelCreditEdit = () => {
    setCreditEdit(false);
    setCreditEditedData([]);
  };

  const onEditClick = () => {
    setCreditEdit(true);
    const crediData: CreditData[] = metaCreditDitribution?.map((item: any) => ({
      branchId: item?.branchId,
      credit: item?.monthlyCredit,
    }));
    setCreditEditedData(crediData);
  };

  const onBranchClick = (item: any) => {
    const id = item.instituteId;
    const status = item.status;
    const branchId = item.branchId;
    const data = { id, status, branchId };
    if (
      hasAllBranchAccess ||
      (!hasAllBranchAccess && branchId === userById?.branchId)
    ) {
      const selectedBranch = branchList?.find(
        (item: any) => item?.id === branchId
      );
      setBranch(selectedBranch);
      setTotalCreditReamining(
        item?.monthlyRemainingCredit + item?.addOnRemainingCredit
      );
      dispatch(getStreams(data));
      setStage(1);
    }
  };

  useEffect(() => {
    if (editCreditDataSuccess) {
      const instituteId = authUser?.institute?.[0]?.instituteId;
      dispatch(getCreditDitribution(instituteId));
      setCreditEdit(false);
      setCreditEditedData([]);
    }
  }, [editCreditDataSuccess]);

  useEffect(() => {
    if (authUser) {
      const instituteId = authUser?.institute?.[0]?.instituteId;
      dispatch(getCreditDitribution(instituteId));
    }
  }, [authUser]);

  return (
    <div>
      <div className={styles.tabHead}>
        <div className={styles.tabHeadLeft}>
          {stage === 1 && (
            <PageBackBtn iconOnly={true} onClick={() => setStage(0)} />
          )}
        </div>
      </div>
      <div>
        <div className={styles.creditTitleBox}>
          <div>
            <div className={styles.creditTitle}>
              {stage === 1
                ? "Credit used Per stream under every branch"
                : "Credit Distribution"}
            </div>
            <div className={styles.creditDesc}>
              {stage === 1
                ? `${branch?.branchName} (Total credit remaining  - ${totalCreditRemaining})`
                : "Check your distribution flow"}
            </div>
          </div>
          <div>
            <div className={styles.tabHeadRight}>
              <BuyAddons />
              {!creditEdit && hasAllBranchAccess && stage === 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    fontSize: 14,
                    textTransform: "capitalize",
                    boxShadow: "none",
                    height: "38px",
                  }}
                  size={"small"}
                  onClick={() => onEditClick()}
                >
                  {/* <EditIcon sx={{ marginRight: "10px", fontSize: "18px" }} /> */}
                  <img
                    src={editIcon}
                    alt="edit"
                    style={{ marginRight: "10px", width: "14px" }}
                  />
                  Edit Credits
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className={styles.creditTableWrap}>
          {stage === 0 && (
            <div style={{ backgroundColor: "#fff", paddingBottom: "20px" }}>
              <div style={{ padding: "0px 23px" }}>
                {metaCreditDitributionLoading ? (
                  <TableSkeleton />
                ) : (
                  <CreditTable
                    creditEdit={creditEdit}
                    metaCreditDitribution={metaCreditDitribution}
                    onBranchClick={onBranchClick}
                    handleCreditChange={handleCreditChange}
                    hasAllBranchAccess={hasAllBranchAccess}
                    onEditClick={onEditClick}
                    creditEditedData={creditEditedData}
                  />
                )}

                {creditEdit && (
                  <div className={styles.creditEditBtnWrapper}>
                    <div>
                      <FormHelperText error={true}>
                        Any changes you make will be applicable from next month
                        onwards
                      </FormHelperText>
                    </div>
                    <div className={styles.creditEditBtnWrap}>
                      <CancelBtn
                        backgroundColor="#fff"
                        onClick={cancelCreditEdit}
                      />
                      <SaveBtn
                        onClick={handleConfirmEdit}
                        buttonText="Confirm"
                        loader={editCreditDataLoading}
                        disabled={editCreditDataLoading}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {stage === 1 && (
            <div style={{ backgroundColor: "#fff", paddingBottom: "20px" }}>
              <div style={{ padding: "0px 23px" }}>
                {streamsLoading ? (
                  <TableSkeleton />
                ) : (
                  <StreamsTable
                    metaStreams={metaStreams}
                    handleTabChange={handleTabChange}
                    handleTabSelect={handleTabSelect}
                    branch={branch}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreditTab;
